import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import React, { FC, Suspense } from 'react'
import { ReportsMenu } from './ImpactMenu'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../../../_metronic/helpers'
import { UserManagementWrapper } from '../data-administration/data-admininstration-list/user-management/userManagementList'
import { WasteCollectorPaymentList } from '../data-administration/data-admininstration-list/waste-collector-payment/wasteCollectorPaymentList'
import { StockWrapper } from '../data-administration/data-admininstration-list/stock/stockList'
import { MonthlyReportWrapper } from '../data-administration/data-admininstration-list/monthly-report/monthlyReportList'
import { WeeklyReportWrapper } from '../data-administration/data-admininstration-list/weekly-report/WeeklyReportList'
import { InvenotryListsWrapper } from '../data-administration/data-admininstration-list/invenotry/inventoryList'
import { UserPerformanceWrapper } from '../data-administration/data-admininstration-list/user-performance/userPerformanceList'
import { WfdWrapper } from '../data-administration/data-admininstration-list/wfd/wfdList'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Impact',
    path: '/apps/impact',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ImpactPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route index element={<ReportsMenu />} />
        <Route
          path='inventory'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Annual Report</PageTitle>
              <InvenotryListsWrapper />
            </>
          }
        />
        <Route
          path='user-performance'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>User Perfomance</PageTitle>
              <UserPerformanceWrapper />
            </>
          }
        />
        <Route
          path='stock'
          element={
            <>
              <PageTitle
                description='View the SKU wise inventory' /* breadcrumbs={usersBreadcrumbs} */
              >
                Stock
              </PageTitle>
              {/* <DataAdmininstrationMenu /> */}
              <StockWrapper />
            </>
          }
        />
        <Route
          path='monthly-reports'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Monthly report</PageTitle>
              {/* <DataAdmininstrationMenu /> */}
              <MonthlyReportWrapper />
            </>
          }
        />


        <Route
          path='weekly-reports'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Weekly Report</PageTitle>
              <WeeklyReportWrapper />
            </>
          }
        />


        <Route
          path='wfd'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>WFD</PageTitle>
              {/* <DataAdmininstrationMenu /> */}
              <WfdWrapper />
            </>
          }
        />
        <Route
          path='inventory'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>User</PageTitle>
              {/* <DataAdmininstrationMenu /> */}
              <MonthlyReportWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default ImpactPage
